var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"div-body"},[_c('van-row',[_c('van-col',{attrs:{"span":"20"}},[_c('div',{staticClass:"div-title"},[_c('span',[_vm._v("发货扫描")])]),_c('div',{staticClass:"div-description"},[_c('span',[_vm._v("发货扫描日期为三包凭证")])])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }